import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { map } from 'rxjs';
import { ReadyForContactFormComponent } from "../../components/ready-for-contact-form/ready-for-contact-form.component";
import { ModuleContainerDirective } from 'src/app/modules/directives/module-container.directive';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-product-archive-page',
  standalone: true,
  imports: [
    CommonModule,
    ModuleContainerDirective,
    AsyncPipe,
    ReadyForContactFormComponent
  ],
  templateUrl: './product-archive-page.component.html',
  styleUrl: './product-archive-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductArchivePageComponent {
  private readonly route = inject(ActivatedRoute);
  public readonly data$ = this.route.data.pipe(map(d => d['data']));
}
